import React, {useState, useEffect} from "react";
import {Button, Form, Grid, Header, Image, Message, Segment} from 'semantic-ui-react'
import './Login.css'
import {useAuth} from "../../../lib/auth/useAuth";
import logo from '../../../img/dijon_logo.png';
import mustardBg from '../../../img/mustarddreams.png'
import MenuTopBar from "../../../components/Menu/MenuTopBar";
import { Link } from "react-router-dom";

function Login(props) {
  let [username, setUsername] = useState("");
  let [password, setPassword] = useState("");
  let auth = useAuth()
  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (!token || token.length <= 10) return;
    // Verify the token is actually valid before redirecting — a stale token
    // would otherwise bounce forever between /login and PrivateRoute.
    auth.isLoggedIn().then((valid) => {
      if (valid) {
        window.location.href = '/';
      } else {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div id={'login-page'}>
      <div id="dashboard">
        <MenuTopBar />
      </div>
      <img style={{ minWidth: '600px', width: '100%', height: '100%', position: 'absolute', left: '0', top: '20px' }} src={mustardBg} />
      <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
        <Grid.Column style={{maxWidth: 450}}>
          {/* <Image centered size={'tiny'} src={logo} alt="Logo"/> */}
          <Header as='h2' className={'white-text'} textAlign='center'>
            {/*Login to your account*/}
          </Header>
          <Form size='large' className={'login-form'} onSubmit={ async () =>  {
            let suc = await auth.signin(username, password);
            if (suc) {
              window.location.href = '/';
            }
          }}>
            <Segment basic stacked className={'login-form'}>
              <Form.Input
                fluid
                icon='user'
                iconPosition='left'
                placeholder='Username'
                name="username"
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
              <Form.Input
                fluid
                icon='lock'
                iconPosition='left'
                placeholder='Password'
                type='password'
                name='password'
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
              <Message
                error
                visible={auth.error}
                header='Incorrect Username or Password'
                content='Please try again.'
              />
              <Button className={'login-btn'} color='blue' fluid size='large' type='submit'>
                Login
              </Button>
            </Segment>
          </Form>
          <Message>
            New to Dijon Dreams? <Link to="/signup">Sign Up</Link>
            <br />
            <Link to="/forgot-password">Forgot your password?</Link>
          </Message>
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default Login;
